module.exports = __webpack_public_path__ + "assets/mediawiki.2cd2100e.svg";